import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { AdvieswijzerComponent } from './advieswijzer/advieswijzer.component';
import { TextResourceResolve } from './services/text-resource.resolve';


const routes: Routes = [
  {
    path: '',
    component: AdvieswijzerComponent,
    pathMatch: 'full',
    data: {
      routeName: '/',
      lang: 'nl'
    },
    resolve: { resources: TextResourceResolve }
  },
  {
    path: 'en',
    component: AdvieswijzerComponent,
    pathMatch: 'full',
    data: {
      routeName: '/',
      lang: 'en'
    },
    resolve: { resources: TextResourceResolve }
  },
  {
    // Wildcard route in case no other match was found.
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(
    routes,
    {
      // enableTracing: true,
      onSameUrlNavigation: 'reload',
      preloadingStrategy: PreloadAllModules
    })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
